import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderLeft from "../../../containers/logged_user_components/structure_components/desktop_screens/header_component/header_left/header_left";
import images from "../../../utilities/images/images";

/** Top bar for Engage homepage: title, stream/class chips, Change Course. */
function EngageHomepageHeader() {
  const history = useHistory();
  const userPreference = useSelector((state) => state.userPreference);
  const userData = useSelector((state) => state.auth.user);

  const selectedStream =
    userPreference?.targetDetails?.[0]?.target ||
    userPreference?.courseDetails?.[0]?.target ||
    "Stream";
  const selectedClass = userPreference?.classDetails?.class || "Class";

  return (
    <div className="engage-homepage__header">
      <div className="engage-homepage__header-leading">
        <button
          type="button"
          className="engage-homepage__back-btn"
          aria-label="Back to dashboard"
          onClick={() => history.push("/dashboard")}
        >
          <img src={images.new_backarrow} alt="" />
        </button>
        <h1 className="engage-homepage__header-title">My Space</h1>
      </div>
      <div className="engage-homepage__header-action">
        <div className="engage-homepage__course-row">
          <div className="engage-homepage__chips">
            <span className="engage-homepage__chip">{selectedStream}</span>
            <span className="engage-homepage__chip">{selectedClass}</span>
          </div>
          <HeaderLeft
            userPreference={userPreference}
            userData={userData}
            redirectToDashboardOnUpdate={false}
            showBatchLabel={false}
            buttonText="Change Course"
            buttonClassName="engage-homepage__change-course-btn"
            buttonIcon={images.courserightangle_icon}
          />
        </div>
      </div>
    </div>
  );
}

export default EngageHomepageHeader;
